import React from "react";
import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import { Clock, LinkSimple, Baby } from "@phosphor-icons/react";
import content from "../data/content.json";
import PageHeader from "../components/PageHeader";
import ListenButton from "../components/ListenButton";
import EmergencyButton from "../components/EmergencyButton";
import { RichText } from "../components/RichText";
import { categoryColor } from "../components/ArticleCard";
import { trackEvent } from "../lib/events";

export default function Article() {
  const { id } = useParams();
  const article = content.articles.find((a) => a.id === id);
  const prema = content.prema.find((a) => a.id === id);
  const item = article || prema;
  const isPrema = !!prema;

  useEffect(() => {
    if (item) trackEvent("fiche_read", item.id);
  }, [item]);

  if (!item) {
    return (
      <div>
        <PageHeader title="Introuvable" back />
        <p className="px-6 text-[15px] text-[#36302B]/60">Cette fiche n'existe pas ou plus.</p>
        <Link to="/bibliotheque" className="mt-4 block px-6 text-[14px] font-bold text-[#C57B67]">
          Retour à la bibliothèque
        </Link>
      </div>
    );
  }

  const color = isPrema ? "#7E70AE" : categoryColor(item.category);
  const phaseLabel = isPrema ? item.category.replace("Prématurité — ", "") : "";

  const FICHE_HEADERS = {
    Sommeil: "/fiches/sommeil.jpg",
    Allaitement: "/fiches/allaitement.jpg",
    Émotions: "/fiches/emotions.jpg",
    Récupération: "/fiches/recuperation.jpg",
    "Récupération Physique": "/fiches/recuperation.jpg",
  };
  const headerImg = !isPrema ? FICHE_HEADERS[item.category] : null;

  return (
    <div>
      <PageHeader title={isPrema ? "Naissance prématurée" : "Fiche bien-être"} back />

      <article className="px-6">
        {headerImg && (
          <div className="mb-4 overflow-hidden rounded-[24px] shadow-[0_6px_24px_rgba(54,48,43,0.08)]">
            <img
              src={headerImg}
              alt={item.category}
              data-testid="fiche-header-image"
              className="aspect-[16/9] w-full object-cover"
            />
          </div>
        )}
        <div className="flex flex-wrap items-center gap-2">
          <span
            className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide"
            style={{ backgroundColor: `${color}22`, color }}
          >
            {isPrema && <Baby size={13} weight="fill" />}
            {isPrema ? phaseLabel : item.category}
          </span>
          {isPrema && item.profile && (
            <span className="rounded-full bg-[#9b8ec4]/12 px-3 py-1 text-[11px] font-bold text-[#7E70AE]">
              {item.profile}
            </span>
          )}
        </div>

        <h2 className="font-display mt-3 text-[27px] font-medium leading-tight text-[#36302B]">
          {item.title}
        </h2>
        {item.read_time && (
          <div className="mt-2 flex items-center gap-1.5 text-[13px] text-[#36302B]/50">
            <Clock size={15} />
            {item.read_time} de lecture
          </div>
        )}

        <div className="mt-5">
          <ListenButton item={item} isPrema={isPrema} phaseLabel={phaseLabel} />
        </div>

        <div className="mt-5">
          <RichText content={item.content} />
        </div>

        {isPrema && (
          <div className="mt-6">
            <EmergencyButton />
          </div>
        )}

        {item.sources && item.sources.length > 0 && (
          <div className="mt-8 rounded-3xl bg-[#F2EDE4] p-5">
            <p className="mb-3 text-[12px] font-bold uppercase tracking-wide text-[#36302B]/50">Sources</p>
            <div className="space-y-2">
              {item.sources.map((s, i) => (
                <a
                  key={i}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`source-link-${i}`}
                  className="flex items-center gap-2 text-[13.5px] font-semibold text-[#C57B67]"
                >
                  <LinkSimple size={16} />
                  {s.label}
                </a>
              ))}
            </div>
          </div>
        )}

        <p className="mt-6 text-center text-[12px] leading-relaxed text-[#36302B]/45">
          Ces informations sont générales et ne remplacent pas l'avis de votre équipe médicale.
        </p>
      </article>
    </div>
  );
}
